export default defineNuxtRouteMiddleware(() => {
  useState(
    'clientIP',
    () => useRequestHeaders()['x-forwarded-for']?.split(',')[0] || '',
  )
})
